import moment from 'moment-timezone'
import config from '../config/config'
import firebase from 'firebase/app'
import 'firebase/database'
import * as Sentry from '@sentry/browser'

firebase.initializeApp(config.FIREBASE_CONFIG)
export const database = firebase.database()

export const checkAdmin = () => {
  const token = getToken()
  return fetch(`${config.URI}/api/v1/check_admin`, {
    method: 'GET',
    headers: {
      'Authenticity-Token': token,
      'Content-Type': 'application/json'
    }
  })
    .then((temp) => temp.json())
    .then(res => {
      if (res.status && res.status === 'success') {
        if (!res.data.admin) {
          alert('管理者ユーザを使用してください')
          window.location = '/'
        }
        return
      }
    })
    .catch((error) => {
      alert('サーバーとの接続にエラーが発生しました。')
      isSentry(error)
    })
}

export const getToken = () => {
  const token = sessionStorage.getItem('authToken')
    ? sessionStorage.getItem('authToken')
    : localStorage.getItem('authToken')
  return token
}

export const checkAdminUrl = url => {
  const substr = 'admin'
  return url.indexOf(substr) !== -1
}

export const getImageURI = (userid, neglect) => {
  const imageURI = userid ? `${config.URI}/api/v1/image/${userid}` : neglect
  return imageURI
}

export const isAccountFree = userPlan => {
  if (userPlan === 'free' || !userPlan) {
    return true
  } else {
    return false
  }
}

export const isAccountStartter = userPlan => {
  const substr = 'starter'
  return userPlan ? userPlan.indexOf(substr) !== -1 : false
}

export const isAccountPremium = userPlan => {
  if (userPlan === 'premium') {
    return true
  } else {
    return false
  }
}

export const checkJapanese = () => {
  let locale = localStorage.getItem('locale')
  if (locale === 'ja') {
    return true
  } else if (locale === 'en') {
    return false
  } else {
    let default_lang =
      (window.navigator.languages && window.navigator.languages[0]) ||
      window.navigator.language ||
      window.navigator.userLanguage ||
      window.navigator.browserLanguage
    if (default_lang === 'ja') {
      localStorage.setItem('locale', 'ja')
      return true
    } else {
      localStorage.setItem('locale', 'en')
      return false
    }
  }
}

export const isActivate = pathname => {
  const substr = 'activate'
  return pathname ? pathname.indexOf(substr) !== -1 : false
}

export const isPassword = pathname => {
  const substr = 'password'
  return pathname ? pathname.indexOf(substr) !== -1 : false
}

export const isChangeEmail = pathname => {
  const substr = 'change_email'
  return pathname ? pathname.indexOf(substr) !== -1 : false
}

export const isSignUp = pathname => {
  const substr = 'signup'
  return pathname ? pathname.indexOf(substr) !== -1 : false
}

export const flattenMessages = (nestedMessages, prefix = '') => {
  return Object.keys(nestedMessages).reduce((messages, key) => {
    let value = nestedMessages[key]
    let prefixedKey = prefix ? `${prefix}.${key}` : key

    if (typeof value === 'string') {
      messages[prefixedKey] = value
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey))
    }

    return messages
  }, {})
}

export const getTimezones = () => {
  const timeZones = moment.tz.names()
  let allTimezones = []
  for (let i in timeZones) {
    allTimezones.push(
      ' (GMT' + moment.tz(timeZones[i]).format('Z') + ') ' + timeZones[i]
    )
  }
  return allTimezones
}

export const parseQuery = qstr => {
  let query = {}
  const a = (qstr[0] === '?' ? qstr.substr(1) : qstr).split('&')
  for (let i = 0; i < a.length; i++) {
    const b = a[i].split('=')
    query[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '')
  }
  return query
}

export const createMarkup = text => {
  return {
    __html: /\\r|\\n|\n/.test(text)
      ? text.replace(/\\r|\\n|\n/g, '<br />')
      : text
  }
}

export const getPlan = () => {
  const APIRoomurl = `${config.URI}/api/v1/rooms`
  return fetch(`${APIRoomurl}`, {
    method: 'GET',
    headers: {
      'Authenticity-Token': getToken(),
      'Content-Type': 'application/json'
    }
  })
    .then((temp) => temp.json())
    .then(res => {
      if (!res.data.sessions_plan) {
        return 'free'
      }
      return res.data.sessions_plan
    })
    .catch((e) => {
      isSentry(e)
      alert('サーバーとの接続にエラーが発生しました。')
    })
}

export const getInvoice = () => {
  return fetch(`${config.URI}/api/v1/stripe_get_invoice`, {
    method: 'GET',
    headers: {
      'Authenticity-Token': getToken(),
      'Content-Type': 'application/json'
    }
  })
    .then((temp) => temp.json())
    .then(res => {
      return res.data
    })
    .catch((e) => {
      isSentry(e)
      alert('サーバーとの接続にエラーが発生しました。')
    })
}

export const getCustomer = () => {
  return fetch(`${config.URI}/api/v1/stripe_get_customer`, {
    method: 'GET',
    headers: {
      'Authenticity-Token': getToken(),
      'Content-Type': 'application/json'
    }
  })
    .then((temp) => temp.json())
    .then(res => {
      return res.data
    })
    .catch((e) => {
      isSentry(e)
      // alert("サーバーとの接続にエラーが発生しました。")
    })
}

export const isSentry = (error) => {
  Sentry.captureException(error)
}



// WEBPACK FOOTER //
// ./src/lib/index.js